import { viewProfile } from './reducer';
export default viewProfile;
